<ng-container *transloco="let t">
  <p-dialog
    #dialog
    [visible]="display$ | async"
    (visibleChange)="onVisibleChange($event)"
    appendTo="body"
    [modal]="true"
    [dismissableMask]="false"
    [draggable]="false"
    [blockScroll]="true"
    styleClass="grid-save-dialog"
  >
    <p-header><i class="fad fa-floppy-disk mr-1"></i> {{ t('core.components.grid.save_dialog.title') }}</p-header>

    <div class="grid" [formGroup]="form" (keydown.enter)="save()">
      <div class="col-12 filters">
        <!-- first row -->
        <div class="p-fluid grid">
          <div class="field col-12">
            <input
              #input
              zTextInput
              formControlName="saveName"
              label="{{ t('core.components.grid.save_dialog.save_id.label') }}"
              placeholder="{{ t('core.components.grid.save_dialog.save_id.placeholder') }}"
              hint="{{ t('core.components.grid.save_dialog.save_id.hint') }}"
              [uppercase]="false"
              [clearButton]="true"
            />
          </div>
        </div>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <p-toolbar styleClass="dialog-toolbar mt-4">
        <div class="p-toolbar-group-left">
          <i *ngIf="(saveLoading$ | async) || (conflictCheckLoading$ | async)" class="pi pi-spin pi-spinner" style="font-size: 1.4rem"></i>
        </div>

        <div class="p-toolbar-group-right">
          <p-button
            *ngIf="(updateExisting$ | async) === false"
            icon="fad fa-check"
            label="{{ t('core.components.grid.save_dialog.save') }}"
            styleClass="p-button-primary"
            (click)="save()"
            [disabled]="!form.get('saveName').value"
          ></p-button>

          <p-button
            *ngIf="(updateExisting$ | async) === true"
            icon="fad fa-check"
            label="{{ t('core.components.grid.save_dialog.update') }}"
            styleClass="p-button-success"
            (click)="update()"
            [disabled]="!form.get('saveName').value"
          ></p-button>

          <p-button
            (click)="close()"
            label="{{ t('core.components.grid.save_dialog.cancel') }}"
            styleClass="p-button-secondary ml-2"
          ></p-button>
        </div>
      </p-toolbar>
    </ng-template>
  </p-dialog>
</ng-container>
